import { emptyAggregate } from './tags.js';
/**
 * Flattens the state's node records into what a `nodeState` predicate reads.
 *
 * Two things that are not cast state vars are folded in, because rules need to
 * ask about them in the same breath: a puppet's `credibility`, so a rule can
 * test how convincing the impression currently is, and the player's Corporate
 * Cred, which lives on the state rather than in the cast.
 */
export function nodeVarsOf(state) {
    const vars = {};
    for (const [nodeId, node] of Object.entries(state.nodes))
        vars[nodeId] = { ...node.vars };
    for (const [nodeId, puppet] of Object.entries(state.puppets)) {
        vars[nodeId] = { ...(vars[nodeId] ?? {}), credibility: puppet.credibility };
    }
    vars['player'] = { ...(vars['player'] ?? {}), cred: state.cred };
    return vars;
}
/**
 * The context for a predicate asked about the *world* rather than about an
 * assembly: an objective, a scheduled event's guard, a chatter pool's condition.
 *
 * There is no assembly, so the aggregate is empty and the selection is empty —
 * which means a world predicate written against tag axes is simply false rather
 * than a special case. The travelling proposal is the object such a predicate is
 * meant to reach for, and `proposal:` leaves read it as usual.
 *
 * `resolvingNodeId` defaults to `player`, so a bare `nodeState` leaf in an
 * objective reads the player's own vars; a chatter pool passes the node whose
 * mood is being tested.
 */
export function worldContext(loaded, state, resolvingNodeId = 'player') {
    return {
        aggregate: emptyAggregate(),
        selection: [],
        particles: loaded.particles,
        identity: state.identity,
        resolvingNodeId,
        nodeVars: nodeVarsOf(state),
        proposal: state.proposal,
        day: state.clock.day,
        phase: state.clock.phase,
        channelId: state.activeChannelId ?? '',
        flags: state.flags,
        strikes: state.pip.strikes,
        // No assembly, so no opener, so nothing for a perk to excuse.
        toneOverride: false,
    };
}
//# sourceMappingURL=context.js.map